/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Address object, used in the Site object */
export interface Address {
  /** Street name */
  street: string;
  /** City */
  city: string;
  /** State */
  state: string;
  /** Postal Code */
  postalCode: string;
  /** Country */
  country: string;
  /** Country code Alpha 2, ie SE, GB */
  countryCode?: string | null;
  /** GPS Coordinates object, used in the Address object */
  gpsCoordinates: GPSCoordinates;
  /** Name of the address to help Maps to show it correctly. Used for localized names ie "Neko Health Center" */
  name?: string;
}

/** The answer to a question in a questionnaire */
export interface AnswerPayload {
  /** The type of the answer */
  $type: string;
}

/** Information about a patient currently assigned to a room. */
export interface AssignedPatient {
  /**
   * The patient currently assigned.
   * @format string
   */
  patientId?: string;
  /**
   * Optional visit which the assignment comes from.
   * @format uuid
   */
  visitId?: string | null;
  /**
   * The time when the assignment was made.
   * @format date-time
   */
  timestamp?: string;
  /** Information about who or what created or modified an item */
  auditRecord?: AuditRecord;
}

/** Audit information */
export interface AuditInformation {
  /** Information about who or what created or modified an item */
  created?: AuditRecord;
  /** Information about who or what created or modified an item */
  lastModified?: AuditRecord;
}

/** Information about who or what created or modified an item */
export interface AuditRecord {
  /** The user or principal */
  userUri: string | null;
  /**
   * When the operation was recorded
   * @format date-time
   */
  timeStamp: string;
  /**
   * The traceId for the operation which
   * created this audit record
   */
  traceId: string;
}

/** Request to book a time slot for patient */
export interface BookSlotRequest {
  /** Patient Id */
  patientId: string;
  /**
   * The booking token to use
   * @format uuid
   */
  bookingTokenId?: string | null;
}

/** A bookable slot */
export interface BookableSlot {
  /**
   * The slot id
   * @example "6B962824-0B9D-4097-9411-5530331C1BB9"
   */
  slotId: string;
  /**
   * The site id
   * @example "2CDE45B7-CC15-44CC-9967-F5C2BAE3B287"
   */
  siteId: string;
  /**
   * The site name
   * @example "Östermalmstorg"
   */
  siteName: string;
  /**
   * The start time in local time
   * @format date-time
   * @example "2024-03-15T13:00:00"
   */
  startTime: string;
  /**
   * The end time in local time
   * @format date-time
   * @example "2024-03-15T14:00:00"
   */
  endTime: string;
  /** Whether the slot can be booked */
  isOpenPublicly: boolean;
  /**
   * The ETag
   * @example "27236F5696CB"
   */
  eTag: string;
}

/** Envelope for paginated responses */
export interface BookableSlotPaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: BookableSlot[];
}

/** Booking Token - allows booking slots */
export interface BookingTokenV2 {
  /**
   * Id of the booking token
   * @format uuid
   */
  bookingTokenId: string;
  /** Id of the Patient owner of the token */
  patientId: string;
  /**
   * Id of the slot the token is redeemed to book
   * @format uuid
   */
  slotId?: string | null;
  /** Is the token available for booking */
  availableForBooking: boolean;
  /** ETag - version of the token's state */
  eTag: string;
  /**
   * Order Id associated with the token
   * @format uuid
   */
  orderId?: string | null;
  /**
   * Booking Abandonment Notification Id
   * @format uuid
   */
  bookingAbandonmentNotificationId?: string | null;
}

/** Envelope for paginated responses */
export interface BookingTokenV2PaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: BookingTokenV2[];
}

/** Boolean answer */
export type BooleanAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The value of the answer */
  value: boolean;
};

/** The request body for cancelling a job. */
export interface CancelJobRequest {
  /** An optional note to add to the events. */
  note?: string | null;
}

/** Request to cancel a Stripe Payment Intent */
export interface CancelPaymentIntentRequest {
  /** Payment Intent Id */
  paymentIntentId: string;
}

/** When to display this consent to the patient */
export enum ConsentDisplayStage {
  AccountCreation = "AccountCreation",
  Booking = "Booking",
  PreVisit = "PreVisit",
  DuringVisit = "DuringVisit",
}

/** Description of a consent */
export interface ConsentMetadata {
  /** Consent Id */
  consentId: string;
  /** Documents to read by language */
  documents: LanguageUri[];
  /** Stage when to show the consent */
  displayStages: ConsentDisplayStage[];
  /** Consent type */
  consentType: ConsentType;
  /**
   * Default expiration of the consent
   * @format date-span
   */
  defaultExpiration: string | null;
  /** Signature type for a consent */
  signatureType: ConsentSignatureType;
  /** If we should ask for consent when patient is at stage (for example, every visit) */
  askConsentEveryTime: boolean;
  /** If true, allows opt out and is not required to perform a scan */
  optional: boolean;
}

/** A signed consent */
export interface ConsentSignature {
  /**
   * The ID of the patient who signed this consent
   * @format string
   */
  patientId: string;
  /**
   * The ID of the consent
   * @format uuid
   */
  id: string;
  /**
   * When the consent was created, which is the same as
   * the time it was signed.
   * @format date-time
   */
  signedAt: string;
  /**
   * The time when the consent expires.
   * @format date-time
   */
  expiresAt?: string;
  /** Whether the consent has expired or not */
  expired: boolean;
  /** Whether the consent was opted out or not */
  optedOut: boolean;
  /**
   * What type of signature or authorization method
   * was used to sign this consent
   */
  signatureType: string;
  /**
   * The URL of the document which was signed. This Url currently
   * implies which claims the user consented to.
   * @format uri
   */
  documentUri: string;
  /** Audit information */
  audit: AuditInformation;
  /** Information about who or what created or modified an item */
  revocationAuditRecord?: AuditRecord;
  /** Information about who or what created or modified an item */
  exclusionAuditRecord?: AuditRecord;
  /** Information about who or what created or modified an item */
  optOutAuditRecord?: AuditRecord;
  /** This consent requires a counter-signature */
  counterSignatureRequired?: boolean;
  /** Consent Metadata Id */
  consentMetadataId?: string;
  /** Information about who or what created or modified an item */
  counterSignatureAuditRecord?: AuditRecord;
}

/** Signature type for a consent */
export enum ConsentSignatureType {
  Self = "self",
  OnBehalf = "onBehalf",
}

/** A summary of a signed consent */
export interface ConsentSummary {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  expiresAt: string;
  expired: boolean;
  optedOut: boolean;
  signatureType: string;
  /** @format uri */
  documentUrl: string;
  counterSignatureRequired: boolean;
  /** ID of the consent */
  consentId: string;
  /** If the consent was revoked */
  revoked?: boolean;
  /**
   * When the consent was revoked
   * @format date-time
   */
  revokedAt?: string | null;
}

/** Consent type */
export enum ConsentType {
  Gdpr = "Gdpr",
  Study = "Study",
  Other = "Other",
}

/** Consent and possibly a signature if it is there */
export interface ConsentWithSignature {
  /** Description of a consent */
  consentMetadata: ConsentMetadata;
  /** A summary of a signed consent */
  relevantSignature: ConsentSummary;
}

/** Envelope for paginated responses */
export interface ConsentWithSignaturePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: ConsentWithSignature[];
}

/** Site of the room, namely Clinic/Location */
export interface CreateSiteRequest {
  /** Id of the site */
  siteId: string;
  /** Site name */
  siteName: string;
  /** Address object, used in the Site object */
  address: Address;
  /** String representing the TimeZoneId */
  timeZoneId: string;
  /** Patient Group Ids (Azure groups) */
  patientGroupIds: string[];
  /** Consents that are required for patient to sign */
  consents: ConsentMetadata[];
}

/** Request to create a new booking slot v2. */
export interface CreateSlotV2Request {
  /**
   * Start time of the slot.
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot.
   * @format date-time
   */
  endTime: string;
  /** Room that this slot belongs to */
  roomId: string;
  /** Visit type of this slot */
  visitTypeId: string;
  /** Whether this slot should show up in PatientApp */
  isOpenPublicly: boolean;
}

export interface CreateStripeConnectionTokenRequest {
  /**
   * Any valid ISO3166 alpha-2 or alpha-3 code.
   * @format string
   * @example "SE"
   */
  country?: string;
}

export interface CreateStripeConnectionTokenResponse {
  secret?: string;
}

/** Enum answer */
export type EnumAnswerPayload = AnswerPayload & {
  $type?: string;
  /**
   * The value of the answer
   * @format int32
   */
  value: number;
  /** The label of the answer */
  label: string;
};

/** GPS Coordinates object, used in the Address object */
export interface GPSCoordinates {
  /**
   * Latitude
   * @format double
   */
  latitude: number;
  /**
   * Longitude
   * @format double
   */
  longitude: number;
}

export interface InitiateCheckoutRequest {
  /** @format uri */
  successUrl?: string;
  /** @format uri */
  failedUrl?: string;
}

export interface InitiateCheckoutResponse {
  /** @format string */
  owner?: string;
  checkoutData?: StripeCheckoutData;
}

/** Job */
export interface Job {
  /** The id of the job */
  jobId: string;
  /** The state of a job */
  state: JobState;
  /** JobTypeName */
  jobTypeName: string;
  /**
   * A range between [0.0-1.0] maps to 0% and 100%, <0.0 means indeterminate
   * @format double
   */
  progress?: number;
  /** Events */
  events: JobEvent[];
  /** Checkpoints */
  checkpoints: JobCheckpoint[];
  /** Whether cancellation is supported or not. */
  cancellationSupported?: boolean;
}

/** A checkpoint in a job */
export interface JobCheckpoint {
  /** @format date-time */
  timestamp?: string;
  checkpoint?: string;
  traceId?: string | null;
}

/**
 * Information about an event which happened during the processing of a job,
 * used to record state transitions.
 */
export interface JobEvent {
  /** The state of a job */
  state?: JobState;
  /** Information about who or what created or modified an item */
  auditRecord: AuditRecord;
  /** An optional note. */
  note?: string | null;
}

/** The state of a job */
export enum JobState {
  Pending = "Pending",
  Scheduled = "Scheduled",
  Running = "Running",
  PauseRequested = "PauseRequested",
  Paused = "Paused",
  ResumeRequested = "ResumeRequested",
  Failed = "Failed",
  CancellationRequested = "CancellationRequested",
  Cancelled = "Cancelled",
  EmergencyStopRequested = "EmergencyStopRequested",
  Stopped = "Stopped",
  Complete = "Complete",
}

/** Uri by language */
export interface LanguageUri {
  language?: string;
  /** @format uri */
  uri?: string;
}

/** Text answer */
export type NumberAnswerPayload = AnswerPayload & {
  $type?: string;
  /**
   * The value of the answer
   * @format double
   */
  value: number;
};

/** Represents the price of a product in a specific country */
export interface ProductCountryPrice {
  /**
   * The currency of the price
   * @format string
   * @example "SEK"
   */
  currency?: string;
  /**
   * The original price of the product before any discounts are applied
   * @format double
   */
  originalPrice?: number;
  /**
   * The final price of the product including any discounts applied, if any
   * @format double
   */
  price?: number;
  /** The discount code that was applied to the price, if any */
  discountCode?: string | null;
}

/** A question and answer which is part of a Questionnaire */
export interface QuestionAnswer {
  /**
   * The ID for the question to identify the question in the questionnaire
   * without knowing the question label text.
   *
   * Only unique in a questionnaire.
   */
  questionId: string;
  /**
   * The language in which the question was presented to the
   * user and is assumed to have been answered by the user.
   *
   * Any valid ISO639 alpha-3 code.
   * @format string
   * @example "SV"
   */
  languageCode: string;
  /**
   * The text of the question as presented to the user, this
   * question should be in the language specified in `LanguageCode`
   */
  label: string;
  /** The text of the question, but the untranslated english version. */
  englishLabel?: string | null;
  /** The answer to the question. */
  answer?:
    | TextAnswerPayload
    | NumberAnswerPayload
    | TextArrayAnswerPayload
    | BooleanAnswerPayload
    | EnumAnswerPayload
    | StringEnumAnswerPayload
    | null;
}

/** A question and answer */
export interface QuestionnaireQuestionResponse {
  /**
   * The type of the questionnaire
   * @format string
   */
  questionnaireType: string;
  /** The patient who owns this response */
  patientId: string;
  /**
   * The ID of this response
   * @format uuid
   */
  responseId: string;
  /** A question and answer which is part of a Questionnaire */
  questionAndAnswer: QuestionAnswer;
  /**
   * VisitId
   * @format uuid
   */
  visitId?: string | null;
  /** Audit information */
  audit: AuditInformation;
}

/** Envelope for paginated responses */
export interface QuestionnaireQuestionResponsePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: QuestionnaireQuestionResponse[];
}

/** A response to a questionnaire */
export interface QuestionnaireResponse {
  /** The type of the questionnaire */
  questionnaireType: string;
  /** The patient who owns this response */
  patientId: string;
  /**
   * The ID of this response
   * @format uuid
   */
  responseId: string;
  /** The questions and answers */
  questionsAndAnswers: QuestionAnswer[];
  /** The state of a questionnaire response */
  state: QuestionnaireResponseState;
  /**
   * VisitId
   * @format uuid
   */
  visitId?: string | null;
  /**
   * Timestamp for creation
   * @format date-time
   */
  responseCreatedAt?: string | null;
  /**
   * Timestamp for completion
   * @format date-time
   */
  responseCompletedAt?: string | null;
  /** Audit information */
  audit?: AuditInformation;
}

/** Envelope for paginated responses */
export interface QuestionnaireResponsePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: QuestionnaireResponse[];
}

/** The state of a questionnaire response */
export enum QuestionnaireResponseState {
  Incomplete = "incomplete",
  Complete = "complete",
}

/** Room in a clinic. Contains Site information, and supported visit types */
export interface Room {
  /** Id of the room */
  id: string;
  /** Display name of the room */
  displayName: string | null;
  /**
   * Id of the patient group of the clinic in which the room is present
   * @format uuid
   */
  patientGroupId: string | null;
  /** Site of the room, namely Clinic/Location */
  site?: Site;
  /** Types of visits that rooms supports. ie Scan, blood pressure checks, maintenance etc */
  supportedVisitTypes?: VisitType[] | null;
  /** Information about a patient currently assigned to a room. */
  assignedPatient?: AssignedPatient;
}

/** Represents a room with SlotsV2 */
export interface RoomWithSlotsV2 {
  /** Id of the room */
  roomId: string;
  /** Display name of the room */
  displayName: string | null;
  /**
   * Id of the patient group of the clinic in which the room is present
   * @format uuid
   */
  patientGroupId: string | null;
  /** Site of the room, namely Clinic/Location */
  site: Site;
  /** Slots of the room */
  slots?: ScheduleViewSlotV2[];
}

/** Envelope for paginated responses */
export interface RoomWithSlotsV2PaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: RoomWithSlotsV2[];
}

/** Represents the details of a patient for a scheduled view slot. */
export interface ScheduleViewSlotPatientDetailsV2 {
  /** The patient ID to whom the slot is booked. */
  patientId: string;
  /** The display name of the patient to whom the slot is booked. */
  displayName: string | null;
  /** Whether the patient has finished onboarding questionnaire. */
  finishedOnboarding: boolean;
  /** Whether the patient has a verified identity. */
  hasVerifiedIdentity: boolean;
}

/** Slot with patient information to show in the schedule view in Doctor UI */
export interface ScheduleViewSlotV2 {
  /** The ID of the Site. */
  siteId: string;
  /** The ID of the Slot. It's a composite key consisting of {SiteId}_{SlotId} */
  slotId: string;
  /**
   * Start time of the slot in local time.
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot in local time
   * @format date-time
   */
  endTime: string;
  /** Represents the details of a patient for a scheduled view slot. */
  patientDetails: ScheduleViewSlotPatientDetailsV2;
  /** Whether this slot is free to be booked. */
  isFree: boolean;
  /** Whether the patient has been checked in. */
  checkedIn: boolean;
  /** Whether this slot can be seen by PatientApp */
  isOpenPublicly: boolean;
  /** Whether this slot is booked. */
  isBooked: boolean;
  /** Room Id where the slot will take place */
  roomId: string;
  /** ETag */
  eTag: string;
}

/** Site of the room, namely Clinic/Location */
export interface Site {
  /** Id of the site */
  siteId: string;
  /** Site name */
  siteName: string;
  /** Address object, used in the Site object */
  address: Address;
  /** String representing the TimeZoneId */
  timeZoneId: string;
  /** Consents that are required for patient to sign */
  consents: ConsentMetadata[];
}

/** Envelope for paginated responses */
export interface SitePaginatedResponse {
  /** Continuation token to fetch the next page if it exists. */
  nextPage: string | null;
  /** The items in this response. */
  items: Site[];
}

/** A booking SlotV2 */
export interface SlotV2 {
  /**
   * The ID of the Slot.
   * Composite key consisting of SiteId and SlotId
   */
  slotId: string;
  /** Room in a clinic. Contains Site information, and supported visit types */
  room: Room;
  /**
   * Start time of the slot with offset.
   * The timezone of the datetime will be in the timezone of the site
   * @format date-time
   */
  startTime: string;
  /**
   * End time of the slot with offset.
   * The timezone of the datetime will be in the timezone of the site
   * @format date-time
   */
  endTime: string;
  /** The patient ID to whom the slot is booked. */
  patientId: string | null;
  /**
   * The booking token ID to which the slot is booked.
   * @format uuid
   */
  bookingTokenId: string | null;
  /**
   * Whether this slot can be shown in PatientApp or not.
   * A slot that is not open publicly cannot be booked by a member, but can be booked in DoctorUI if there's no patientId set
   * A slot that is open publicly and doens't have a patientId set can be booked in PatientApp or DoctorUI
   * Calculated from PatientId and IsOpenPublicly.
   */
  isOpenPublicly: boolean;
  /**
   * Whether this slot is free to be booked or not.
   * Calculated from PatientId and IsOpenPublicly.
   * IsBooked and IsOpenPublicly are false when true
   */
  isFree: boolean;
  /** The id of the visit type that this slot allows, default = "Scan" */
  visitTypeId: string;
  /** ETag */
  eTag: string;
}

/** Enumeration to describe sort order */
export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}

/** StringEnum answer */
export type StringEnumAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The value of the answer */
  value: string;
  /** The label of the answer */
  label: string;
};

export interface StripeCheckoutData {
  intentId?: string;
  clientSecret?: string;
  currency?: string;
  countryIso?: string;
  /** @format int64 */
  amount?: number;
  /** @format uri */
  completeCheckoutUrl?: string;
}

/** Text answer */
export type TextAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The text value of the answer */
  value: string;
};

/** Text array answer */
export type TextArrayAnswerPayload = AnswerPayload & {
  $type?: string;
  /** The value of the answer */
  value: string[];
};

/** Request to unbook a slot */
export interface UnBookSlotRequest {
  /** Should refund token */
  refundToken?: boolean;
}

/** Site of the room, namely Clinic/Location */
export interface UpdateSiteRequest {
  /** Display name of the site in the site's primary language. */
  displayName: string | null;
  /** Address object, used in the Site object */
  address: Address;
  /** The timezone id of the site. */
  timeZoneId: string | null;
  /** The list of patient groups which can access this site. */
  patientGroupIds: string[] | null;
}

/** A type of a visit, ie scan, blood pressue check, maintenance etc. */
export interface VisitType {
  visitTypeId: string;
  /** @format int32 */
  defaultLengthMinutes: number;
  consents: ConsentMetadata[];
}

export interface BillingV2StripeCompleteCheckoutParams {
  payment_intent_client_secret?: string;
  payment_intent?: string;
  redirect_status?: string;
  /** @format string */
  patientId: string;
}

export interface BillingV2GetProductPriceByCountryParams {
  /** Discount token code to apply to the product price */
  discountCode?: string;
  /**
   * Product ID
   * @format uuid
   */
  productId: string;
  country: string;
}

export interface BookingV2QueryBookableSlotsParams {
  /** Only return slots from these SiteIds */
  siteIds?: string[];
  /**
   * Inclusive
   * @format date-time
   */
  "startTimeRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "startTimeRange.end"?: string;
  /** Include slots with IsOpenPublicly==false, cannot be specified if the caller is a patient */
  includeClosedForPublicSlots?: boolean;
  /** Only return slots from these VisitTypeIds */
  visitTypeIds?: string[];
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
}

export interface BookingTokenQueryPatientsParams {
  /** @default true */
  availableForBooking?: boolean;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * Owner patient
   * @format string
   */
  patientId: string;
}

export interface PatientConsentV2RenderPatientConsentHistoryParams {
  /** Short-lived token obtained from GetEphemeralToken API */
  token: string;
  /**
   * The patient
   * @format string
   */
  patientId: string;
  consentId: string;
}

export interface QuestionnaireQueryResponseQuestionAndAnswersParams {
  /**
   * Inclusive
   * @format date-time
   */
  "createdAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAtRange.end"?: string;
  /** Questionnaire responses are sorted by creation timestamp */
  order?: SortOrder;
  /**
   * Filter by VisitId
   * @format uuid
   */
  visitId?: string;
  /** Filter questions by questionnaire type */
  questionnaireType?: string;
  /** Only include these question IDs */
  questionIds?: string[];
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The ID of the patient
   * @format string
   */
  patientId: string;
}

export interface QuestionnaireQueryPatientResponsesParams {
  /**
   * Inclusive
   * @format date-time
   */
  "createdAtRange.start"?: string;
  /**
   * Exclusive
   * @format date-time
   */
  "createdAtRange.end"?: string;
  /** Questionnaire responses are sorted by creation timestamp */
  order?: SortOrder;
  /**
   * Filter by VisitId
   * @format uuid
   */
  visitId?: string;
  /** Filter responses by questionnaire type */
  questionnaireType?: string;
  /** The continuation token */
  continuationToken?: string;
  /**
   * The page size
   * @format int32
   */
  pageSize?: number;
  /**
   * The ID of the patient
   * @format string
   */
  patientId: string;
}

export interface SiteGet2Params {
  country?: string;
}

export interface SlotV2GetSiteScheduleViewParams {
  /**
   * Inclusive
   * @format date-time
   */
  start?: string;
  /**
   * Exclusive
   * @format date-time
   */
  end?: string;
  /** A continuation token */
  continuationToken?: string;
  /** SiteId for which to get schedule */
  siteId: string;
}
